(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Oregon-Nav"] && !Shopify.designMode) return;
  try {
    


    const navItems = document.querySelectorAll('.on-pages');
    const overlay = document.getElementById('js--nav-overlay');

    navItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            overlay.style.display = 'block';
        });

        item.addEventListener('mouseleave', () => {
            overlay.style.display = 'none';
        });
    });

    document.querySelector('.on-bars').addEventListener('click', function() {
        const menu = document.querySelector('.on-pages');
        menu.classList.toggle('mobile-menu-open');
    });

    (function() {
    var form    = document.getElementById('predictive-search-form');
    var input   = document.getElementById('predictive-search-input');
    var panel   = document.getElementById('predictive-search-panel');
    var listbox = document.getElementById('predictive-search-listbox');
    var seeAll  = document.getElementById('predictive-search-see-all');

    var activeIndex = -1;
    var items = [];
    var controller; // AbortController for debouncing fetch

    function showPanel() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
    }
    function hidePanel() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        activeIndex = -1;
        items = [];
        listbox.innerHTML = '';
        seeAll.hidden = true;
    }

    function setActive(i) {
        if (!items.length) return;
        items.forEach(function(el, idx) {
        el.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        });
        activeIndex = i;
    }

    function productItemHTML(p) {
        var img = (p.image && p.image) ? p.image : (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
        var vendor = (p.vendor || '').toString();
        var title  = (p.title || '').toString();
        var url    = p.url || (p.handle ? ('/products/' + p.handle) : '#');

        return '' +
        '<li class="predictive-search-item" role="option" tabindex="-1" data-href="'+ escapeHtml(url) +'">' +
            (img ? '<img class="predictive-search-thumb" src="'+ escapeHtml(img) +'" alt="">' : '<div class="predictive-search-thumb" aria-hidden="true"></div>') +
            '<div class="predictive-search-meta">' +
            '<div class="predictive-search-title">'+ escapeHtml(title) +'</div>' +
            (vendor ? '<div class="predictive-search-vendor">'+ escapeHtml(vendor) +'</div>' : '') +
            '</div>' +
        '</li>';
    }

    function escapeHtml(s) {
        return (s||'').toString()
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;')
        .replace(/'/g,'&#039;');
    }

    function buildSeeAll(q) {
        var href = '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
        seeAll.innerHTML = '<a href="'+ href +'">See all results for “'+ escapeHtml(q) +'”</a>';
        seeAll.hidden = false;
    }

    function fetchSuggestions(q) {
        // Debounce: cancel previous request
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;

        // Shopify Predictive Search endpoint
        var url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,vendor,product_type,variants.title';

        return fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
        .then(function(data) {
            var products = [];
            // OS 2.0 returns data.resources.results.products; older may return data.resources.results.products too
            if (data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)) {
            products = data.resources.results.products;
            } else if (data && data.resources && Array.isArray(data.resources.products)) {
            products = data.resources.products;
            }
            return products;
        });
    }

    function renderList(products, q) {
        if (!products || !products.length) {
        hidePanel();
        return;
        }
        var html = products.map(productItemHTML).join('');
        listbox.innerHTML = html;
        items = Array.prototype.slice.call(listbox.querySelectorAll('.predictive-search-item'));
        items.forEach(function(el, idx){
        el.addEventListener('mouseenter', function(){ setActive(idx); });
        el.addEventListener('mouseleave', function(){ setActive(-1); });
        el.addEventListener('mousedown', function(e){
            // Prevent input blur before we navigate
            e.preventDefault();
        });
        el.addEventListener('click', function(){
            var href = el.getAttribute('data-href') || '#';
            if (href && href !== '#') window.location = href;
        });
        });
        buildSeeAll(q);
        setActive(-1);
        showPanel();
    }

    function onInput() {
        var q = input.value.trim();
        if (q.length < 2) { hidePanel(); return; }
        // small debounce
        clearTimeout(onInput._t);
        onInput._t = setTimeout(function(){
        fetchSuggestions(q)
            .then(function(products){ renderList(products, q); })
            .catch(function(){ /* silently ignore */ });
        }, 150);
    }

    function onKeydown(e) {
        if (panel.hidden) return;
        var key = e.key;
        if (key === 'ArrowDown') {
        e.preventDefault();
        if (!items.length) return;
        setActive((activeIndex + 1) % items.length);
        items[activeIndex].focus();
        } else if (key === 'ArrowUp') {
        e.preventDefault();
        if (!items.length) return;
        setActive((activeIndex - 1 + items.length) % items.length);
        items[activeIndex].focus();
        } else if (key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) {
            e.preventDefault();
            items[activeIndex].click();
        }
        // else let form submit normally
        } else if (key === 'Escape') {
        hidePanel();
        }
    }

    // Submit fallback: ensure proper search URL if something is intercepting default
    form.addEventListener('submit', function(e){
        var q = (input.value || '').trim();
        if (!q) { e.preventDefault(); return; }
        // Force a clean product search URL
        form.action = '/search';
        // allow form to submit; browsers will include q + hidden fields
    });

    // Click-away close
    document.addEventListener('click', function(e){
        if (!form.contains(e.target)) hidePanel();
    });

    // Wire events
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKeydown);
    input.addEventListener('focus', onInput);
    })();

    (function () {
    var MOBILE_QUERY = '(max-width: 800px)';
    function isMobile() { return window.matchMedia(MOBILE_QUERY).matches; }

    function updateArrow(li, isOpen) {
        var arrow = li.querySelector('.on-pages-link__arrow');
        if (!arrow) return;
        arrow.classList.toggle('fa-angle-right', !isOpen);
        arrow.classList.toggle('fa-angle-down', !!isOpen);
    }

    function setA11y(catEl, li) {
        if (isMobile()) {
        catEl.setAttribute('role', 'button');
        catEl.setAttribute('aria-expanded', li.classList.contains('open') ? 'true' : 'false');
        catEl.tabIndex = 0;
        } else {
        catEl.removeAttribute('role');
        catEl.removeAttribute('aria-expanded');
        catEl.removeAttribute('tabindex');
        }
    }

    // Ensure submenu actually opens/closes regardless of other CSS.
    function applyState(li) {
        var submenu = li.querySelector(':scope > .on-pages-link-submenu');
        if (!submenu) return;
        if (isMobile()) {
        var open = li.classList.contains('open');
        submenu.style.display = open ? 'block' : 'none';   // <-- hard toggle
        updateArrow(li, open);
        } else {
        submenu.style.display = ''; // reset inline style on desktop
        updateArrow(li, li.classList.contains('open'));
        }
    }

    function closeSiblings(li) {
        var parent = li.parentElement;
        if (!parent) return;
        parent.querySelectorAll(':scope > .on-pages-link.open').forEach(function (sib) {
        if (sib === li) return;
        sib.classList.remove('open');
        applyState(sib);
        var sibCat = sib.querySelector(':scope > .on-pages-link-category');
        if (sibCat) sibCat.setAttribute('aria-expanded', 'false');
        });
    }

    function bind() {
        document.querySelectorAll('.on-pages .on-pages-link').forEach(function (li) {
        var cat = li.querySelector(':scope > .on-pages-link-category');
        var submenu = li.querySelector(':scope > .on-pages-link-submenu');
        if (!cat || !submenu) return;

        setA11y(cat, li);
        applyState(li);

        if (cat.dataset.bound === '1') return;
        cat.dataset.bound = '1';

        // Toggle on mobile: prevent navigation and truly open/close submenu
        cat.addEventListener('click', function (e) {
            if (!isMobile()) return;
            e.preventDefault(); // block navigation for mobile tap
            li.classList.toggle('open');
            cat.setAttribute('aria-expanded', li.classList.contains('open') ? 'true' : 'false');
            applyState(li);
            closeSiblings(li);
        });

        // Keyboard toggle support on mobile
        cat.addEventListener('keydown', function (e) {
            if (!isMobile()) return;
            if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            cat.click();
            }
        });
        });
    }

    document.addEventListener('DOMContentLoaded', bind);

    // On resize, re-apply correct visibility and a11y, and clear inline styles for desktop.
    window.addEventListener('resize', function () {
        document.querySelectorAll('.on-pages .on-pages-link').forEach(applyState);
        document.querySelectorAll('.on-pages .on-pages-link-category').forEach(function (cat) {
        var li = cat.closest('.on-pages-link');
        if (li) setA11y(cat, li);
        });
    });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Static-Categories"] && !Shopify.designMode) return;
  try {
    
// if screen width is below 620px add margin below cat image to match Maintanence Parts button alignment.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Tri-Banner"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.OTB-block').forEach(block => {
        const btn = block.querySelector('.OTB-btn');
        btn.addEventListener('mouseenter', () => {
            block.classList.add('no-tint');
        });
        btn.addEventListener('mouseleave', () => {
            block.classList.remove('no-tint');
        });
    });

  } catch(e) { console.error(e); }
})();
})();
